import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import {Link} from "react-router-dom";
import Button from '../../../components/ui/Button';

const DocumentCard = ({ coach }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';

    const date = new Date(dateStr);
    if (isNaN(date)) return dateStr;

    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  return (
    <div className="relative bg-white rounded-lg literary-shadow hover:literary-shadow-elevated literary-transition literary-border overflow-hidden">
      {!coach.stock && (
          <span className="absolute top-2 right-2 bg-red-600 text-white text-xs font-semibold px-2 py-1 rounded z-10">
        Agotado
      </span>
      )}
      {coach.stock && (
          <span className="absolute top-2 right-2 bg-green-600 text-white text-xs font-semibold px-2 py-1 rounded z-10">
        Disponible
      </span>
      )}
      <div className="relative h-48 overflow-hidden bg-gray-200">
        <Image
            src={coach?.image}
            alt=""
            className="absolute inset-0 w-full h-full object-cover blur-md scale-110 opacity-40"
        />
        <Image
            src={coach?.image}
            alt={coach?.title}
            className="relative w-full h-full object-contain"
        />
      </div>


      {/* Coach Content */}
      <div className="p-6">
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1">
            <h3 className="font-headline text-lg font-semibold text-primary mb-2 line-clamp-2">
              {coach?.title}
            </h3>
            <div className="flex items-center space-x-4 text-sm text-scholarly-gray mb-3">
              <div className="flex items-center space-x-1">
                <Icon name="Calendar" size={14} className="text-blue-500" />
                <span className="font-body">{formatDate(coach?.date.beginning)}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="MapPin" size={14} className="text-red-500" />
                <span className="font-body">{coach?.location.name}</span>
              </div>
            </div>
          </div>
        </div>

        <p className="font-body text-foreground text-sm mb-4 line-clamp-3">
          {coach?.description}
        </p>
        {/* Actions */}
        <div className="flex items-center justify-between pt-4 border-t literary-border">
          <Button
            variant="outline"
            size="sm"
            iconName="ExternalLink"
            iconPosition="right"
            asChild
          >
            <Link to={`/coach/${coach?.id}`}>Ver Detalle</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DocumentCard;